import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100" aria-label="网站页脚">
      <div className="container-x grid grid-cols-1 gap-8 py-12 md:grid-cols-2 md:py-14 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-xl text-background-50">
              <i className="ri-book-open-fill" style={{ fontSize: "18px" }}></i>
            </span>
            <span className="font-display text-xl text-background-50">卡通动漫第一页</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-background-100/80">
            聚合今日更新、热门榜单与编辑推荐，高分漫画、人气连载一页全收，每日刷新内容池，帮你快速找到想追的那部。
          </p>
          <div className="mt-5 flex items-center gap-3 text-background-100/80">
            <a href="#" aria-label="新浪微博" className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 hover:bg-primary-500 transition-colors" rel="nofollow">
              <i className="ri-weibo-fill" style={{ fontSize: "16px" }}></i>
            </a>
            <a href="#" aria-label="哔哩哔哩" className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 hover:bg-primary-500 transition-colors" rel="nofollow">
              <i className="ri-bilibili-fill" style={{ fontSize: "16px" }}></i>
            </a>
            <a href="#" aria-label="微信公众号" className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 hover:bg-primary-500 transition-colors" rel="nofollow">
              <i className="ri-wechat-fill" style={{ fontSize: "16px" }}></i>
            </a>
            <a href="#" aria-label="小红书" className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 hover:bg-primary-500 transition-colors" rel="nofollow">
              <i className="ri-bookmark-line" style={{ fontSize: "16px" }}></i>
            </a>
          </div>
        </div>

        <div>
          <h3 className="font-display text-lg text-background-50">快速导航</h3>
          <ul className="mt-4 grid grid-cols-2 gap-2 text-sm text-background-100/80">
            <li><Link to="/" className="hover:text-primary-300 transition-colors">首页</Link></li>
            <li><Link to="/today" className="hover:text-primary-300 transition-colors">今日更新</Link></li>
            <li><Link to="/rank" className="hover:text-primary-300 transition-colors">热门榜单</Link></li>
            <li><Link to="/recommend" className="hover:text-primary-300 transition-colors">编辑推荐</Link></li>
            <li><Link to="/about" className="hover:text-primary-300 transition-colors">关于我们</Link></li>
            <li><Link to="/contact" className="hover:text-primary-300 transition-colors">联系我们</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="font-display text-lg text-background-50">热门分类</h3>
          <ul className="mt-4 flex flex-wrap gap-2 text-sm text-background-100/80">
            {categories.slice(1).map((c) => (
              <li key={c}>
                <Link to={`/today?cat=${encodeURIComponent(c)}`} className="rounded-full bg-white/10 px-3 py-1.5 hover:bg-primary-500 hover:text-background-50 transition-colors whitespace-nowrap">
                  {c}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-display text-lg text-background-50">联系我们</h3>
          <ul className="mt-4 space-y-3 text-sm text-background-100/80">
            <li className="flex items-center gap-3">
              <i className="ri-mail-line" style={{ fontSize: "16px" }}></i>
              <span>service@cartoon1st.example</span>
            </li>
            <li className="flex items-center gap-3">
              <i className="ri-time-line" style={{ fontSize: "16px" }}></i>
              <span>每日 09:00 - 22:00 在线</span>
            </li>
            <li className="flex items-center gap-3">
              <i className="ri-chat-smile-line" style={{ fontSize: "16px" }}></i>
              <span>欢迎反馈想看的内容</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x flex flex-col items-center justify-between gap-3 py-6 text-xs text-background-100/70 sm:flex-row">
          <p>© 2026 卡通动漫第一页 · 仅供内容展示与交流，所有作品版权归原作者所有</p>
          <p className="flex items-center gap-2">
            <i className="ri-heart-line" style={{ fontSize: "14px" }}></i>
            认真推荐每一部好漫画
          </p>
        </div>
      </div>
    </footer>
  );
}